export default "__VITE_ASSET__B7P6ccCS__"